// get array of products uuids
export const getProductsUuids = (products) => products.map(({ uuid }) => uuid);

export const removeItemFromSelected = ({ id, products, setProducts }) => {
	const newSelection = products.filter((item) => item.uuid !== id);
	setProducts(newSelection);
};
